<script setup>
import { ref } from 'vue';
import CloseCirclePanel from './CloseCirclePanel.vue';

defineProps({
  contactId: {
    type: [String, Number],
    required: true,
  },
  contactName: {
    type: String,
    default: '',
  },
  contactPhone: {
    type: String,
    default: '',
  },
  contactEmail: {
    type: String,
    default: '',
  },
  projects: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['createProjectForMember', 'openProject']);

const isOpen = ref(false);
const panelRef = ref(null);

const open = () => {
  panelRef.value?.showList();
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
};

const openMember = member => {
  isOpen.value = true;
  panelRef.value?.openMember(member);
};

const openNewMember = (initial = {}) => {
  isOpen.value = true;
  panelRef.value?.openNewMember(initial);
};

const openLinkedProject = payload => {
  isOpen.value = false;
  emit('openProject', payload);
};

defineExpose({ open, close, openMember, openNewMember });
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-[70] flex items-end justify-center pointer-events-none transition-colors duration-200 ease-in-out"
      :class="
        isOpen
          ? 'pointer-events-auto bg-n-alpha-black1 backdrop-blur-[4px]'
          : 'bg-transparent'
      "
      @click.self="close"
    >
      <div
        class="flex h-[92vh] max-h-[92vh] w-full flex-col overflow-hidden rounded-t-[1.5rem] bg-n-solid-2 shadow-xl transition-transform duration-200 ease-in-out sm:max-w-xl sm:rounded-t-2xl"
        :class="isOpen ? 'translate-y-0' : 'translate-y-full'"
      >
        <CloseCirclePanel
          ref="panelRef"
          :contact-id="contactId"
          :contact-name="contactName"
          :contact-phone="contactPhone"
          :contact-email="contactEmail"
          :projects="projects"
          class="min-h-0 flex-1"
          @close-sheet="close"
          @create-project-for-member="
            member => emit('createProjectForMember', member)
          "
          @open-project="openLinkedProject"
        />
      </div>
    </div>
  </Teleport>
</template>
